<ideal-product-section
  i18n-title="@@products.links.label"
  title="Links"
  navAnchorId="app.main-menu/products/details/links"
  navAnchorHeading="Product"
  i18n-navAnchorHeading="@@products.nav.product.heading"
  [navAnchorHidden]="hasContent() === false"
  class="padded"
>
  <ideal-product-links #content [productId]="id()"></ideal-product-links>
</ideal-product-section>
